// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class PayoutEventsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'payoutEvents';
        this.Server = this.props.context.getState().server.payoutEvents;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['event'];
        this.disableGlobalEditor = true;
        this.disableAdd = true;

        const defaultHead = [
            { id: 'uuid', label: 'uuid', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true },
            { id: 'resourceId', label: 'resourceId', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true },
            { id: 'event', label: 'event', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true },
            { id: 'payload', label: 'payload', alignRight: false, cell: 'Json', displayGrid: true, disableEditor: true },
            { id: 'response', label: 'response', alignRight: false, cell: 'Json', displayGrid: true, disableEditor: true },
            { id: 'dateCreated', label: 'dateCreated', alignRight: false, cell: 'DateTime', displayGrid: true, disableEditor: true }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
